export enum Criticality {
    LOW = "low",
    MEDIUM = "medium",
    CRITICAL = "critical"
}

export interface ClinicalAlert {
    id: string;
    therapist_id: string;
    name: string;
    context: string;
    criticality: Criticality;
}

export interface ClinicalAlertCreate {
    name: string;
    context: string;
    criticality: Criticality;
}

export interface ClinicalAlertUpdate {
    name?: string;
    context?: string;
    criticality?: Criticality;
}
